<template>
    <div>
        <div class="row">
            <div class="col-lg-2">
                <div class="form-group">
                    <label for="datainicial">
                        Data Inicial:
                    </label>
                    <input class="form-control" type="date" id="datainicial" v-model="startDate"/>
                </div>
            </div>
            <div class="col-lg-2">
                <div class="form-group">
                    <label for="datainicial">
                        Data Final:
                    </label>
                    <input class="form-control" type="date" id="datafinal" v-model="endDate"/>
                </div>
            </div>
            <div class="col-lg-3">
                <div class="form-group">
                    <label for="user_id">Contratante</label>
                    <select name="user_id"
                            id="user_id"
                            class="form-control inputPerfil"
                            v-model="selectedUser">
                        <option :value="null" selected>Selecione</option>
                        <option v-for="user in users" :key="user.id" :value="user">
                            {{ user.full_name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-lg-2">
                <div class="form-group">
                    <label for="status">Status</label>
                    <select name="status"
                            id="status"
                            class="form-control inputPerfil"
                            v-model="status">
                        <option :value="null" selected>Todos</option>
                        <option v-for="status in bid_status" :key="status" :value="status">
                            {{ status }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-lg-2">
                <div class="form-group">
                    <label for="field_id">Área de Atuação</label>
                    <select name="field_id"
                            id="field_id"
                            class="form-control inputPerfil"
                            v-model="selectedField">
                        <option :value="null" selected>Selecione</option>
                        <option v-for="field in fields" :key="field.id" :value="field">
                            {{ field.name }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="col-lg-3">
                <div class="form-group">
                    <label for="state_id">Estado</label>
                    <select name="state_id"
                            id="state_id"
                            class="form-control"
                            @change="onChangeState"
                            v-model="selectedState"
                    >
                        <option :value="null">Selecione</option>
                        <option v-for="state in states" :key="state.id" :value="state">
                            {{ state.name }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="col-lg-3">
                <div class="form-group">
                    <label for="location_id">Cidade</label>
                    <select name="location_id"
                            id="location_id"
                            class="form-control"
                            v-model="selectedCity"
                            :disabled="!selectedState"
                            @change="onSelectCity"
                            required
                    >
                        <option :value="null">Selecione</option>
                        <option v-for="city in cities" :key="city.id" :value="city">
                            {{ city.name }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="col-lg-3">
                <div class="form-group">
                    <label for="estimated_value">Valor Estimado Demanda</label>
                    <select name="estimated_value"
                            id="estimated_value"
                            class="form-control inputPerfil"
                            v-model="estimated_value">
                        <option :value="null" selected>Todos</option>
                        <option v-for="estimated_value in bid_estimated_values" :key="estimated_value" :value="estimated_value">
                            {{ estimated_value }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="col-lg-2">
                <div class="form-group">
                    <label for="amount_min_proposal">Valor Min. Proposta</label>
                    <input type="number" placeholder="Valor" class="input form-control" v-model="amount_min_proposal"">
                </div>
            </div>
            <div class="col-lg-2">
                <div class="form-group">
                    <label for="amount_max_proposal">Valor Max. Proposta</label>
                    <input type="number" placeholder="Valor" class="input form-control" v-model="amount_max_proposal">
                </div>
            </div>
            <div class="col-lg-2">
                <div class="form-group">
                    <label for="proposals_made">Quantidade de propostas</label>
                    <input type="number" placeholder="Valor" class="input form-control" v-model="proposals_made">
                </div>
            </div>

            <div class="col-lg-2">
                <div class="form-group">
                    <label for="src_route">Origem</label>
                    <select name="src_route"
                            id="src_route"
                            class="form-control inputPerfil"
                            v-model="src_route">
                        <option :value="null" selected>Todas</option>
                        <option v-for="src_route in bid_src_route" :key="src_route" :value="src_route">
                            {{ src_route }}
                        </option>
                    </select>
                </div>
            </div>

        </div>

        <div class="row">
            <div class="col-lg-12">
                <button type="button" class="btn btn-primary" @click="filterTable">Filtrar</button>
            </div>
        </div>
        <div style="overflow-x:auto; margin-top: 20px">
            <table id="bids_table" class="table table-responsive table-hover table-mail minhasDemandasTable">
                <thead>
                <tr>
                    <th>Data</th>
                    <th>Contratante</th>
                    <th>Área de Atuação</th>
                    <th>Expira Em</th>
                    <th>Peritos Inscritos</th>
                    <th>Propostas realizadas</th>
                    <th>Digital</th>
                    <th>Status</th>
                    <th>Ações</th>
                </tr>
                </thead>
            </table>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        props:{
            users:{
                type:Array
            },
            fields:{
                type:Array
            }
        },
        data(){
            return {
                selectedField:null,
                selectedUser:null,
                status: null,
                dataTable:null,
                startDate:null,
                endDate:null,
                estimated_value:null,
                src_route:null,

                amount_min_proposal:null,
                amount_max_proposal:null,

                proposals_made: null,

                bid_status: [],
                bid_estimated_values: [],
                bid_src_route: [],

                states: [],
                cities: [],
                selectedState: null,
                selectedCity: null,
            }
        },
        mounted(){
            var vm = this;
            $(document).ready(function(){
                vm.dataTable = $('#bids_table').DataTable({
                    searching:false,
                    serverSide:true,
                    ajax:{
                        url:'/admin/demandas/all',
                        method:'GET',
                        data:{'start_date':''}
                    },
                    columns:[
                        {
                            data:'created_at',
                            render:function(data, type, row, meta){
                                return '<a target="_blank" href="/demandas/'+row.id+'">'+moment(data).format('DD/MM/YYYY hh:mm')+'</a>';
                            }
                        },
                        {
                            data:'user.full_name'
                        },
                        {
                            data:'field.name'
                        },
                        {
                            data:'expires_at',
                            render:function(data, type, row, meta){
                                return moment(data).format('DD/MM/YYYY hh:mm')
                            }
                        },
                        {
                            data:'subscriptions',
                            render:function(data, type, row, meta){
                                return data.length
                            }
                        },
                        {
                            data:'bid_proposals_count',
                            render:function(data, type, row, meta){
                                return row.bid_proposals_count + row.proposals_history_count;
                            }
                        },
                        {
                            data:'can_be_done_remotely',
                            render:function(data, type, row, meta){
                                return data == 1 ? 'Sim' : 'Nao'
                            }
                        },
                        {
                            data:'status.status',
                            render:function(data, type, row, meta){
                                return data || 'Sem Status'
                            }
                        },
                        {
                            data:'status.created_at',
                            render:function(data, type, row, meta){
 
                                if(row.status && row.status.status == 'Concluido')
                                    return '<a target="_blank" class="btn btn-primary" href="/pagamentos/admin/'+row.id+'">Pagar Perito</a>';

                                if(row.status && row.status.status == 'Pericia Entregue')
                                    return '<a target="_blank" class="btn btn-warning" href="/pagamentos/admin/'+row.id+'">Pagar Perito</a>';

                                if(row.status && row.status.status == 'Pago')
                                    return '<a target="_blank" class="btn btn-warning" href="/pagamentos/admin/'+row.id+'">Pagar Perito</a>';
                                
                                if(row.status && row.status.status == 'Perito Pago')
                                    return '<button class="btn btn-primary" disabled>Perito Pago</button>';
 
                                return '<button class="btn btn-primary" disabled>Ainda não Concluida</button>';

                            }
                        }
                    ]
                });
                vm.dataTable.on('preXhr.dt', function(e, settings, data){
                    data.start_date = vm.startDate;
                    data.end_date = vm.endDate;
                    data.user_id = vm.selectedUser ? vm.selectedUser.id : '';
                    data.field_id = vm.selectedField ? vm.selectedField.id : '';
                    data.status = vm.status;
                    data.selectedState = vm.selectedState ? vm.selectedState.id : '';
                    data.selectedCity = vm.selectedCity ? vm.selectedCity.id : '';
                    data.selectedCity = vm.selectedCity ? vm.selectedCity.id : '';
                    data.estimated_value = vm.estimated_value;
                    data.amount_min_proposal = vm.amount_min_proposal;
                    data.amount_max_proposal = vm.amount_max_proposal;
                    data.proposals_made = vm.proposals_made;
                    data.src_route = vm.src_route;
                });
            });

            axios.get('/states')
                .then(({data}) => {
                    this.states = data;
                });

            axios.get('/bid/status')
                .then(({data}) => {
                    this.bid_status = data;
                });

                axios.get('/bid/estimated-values')
                .then(({data}) => {
                    this.bid_estimated_values = data;
                });

            axios.get('/src_route')
                .then(({data}) => {
                    this.bid_src_route = data;
                });

        },
        methods: {
            filterTable(){
                this.dataTable.ajax.reload();
            },

            onChangeState() {
                this.cities = [];
                this.selectedCity = null;

                if (!this.selectedState) {
                    return;
                }

                axios.get(`/states/${this.selectedState.id}/cities_0`)
                    .then(({data}) => {
                        this.cities = data.data;
                    });
            },
            onSelectCity() {
                this.$emit('input', this.selectedCity);
            },
        }
    }
</script>